import React from 'react';

const BackspaceIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="66" height="46" viewBox="0 0 66 46" fill="none">
    <path d="M31.5999 15.4286L47.6 30.5714M47.6 15.4286L31.5999 30.5714M26.9999 3C25.5091 3.00008 24.0718 3.52869 22.9679 4.48286L3.98383 20.8829C3.67399 21.1507 3.4264 21.4773 3.25696 21.8416C3.08753 22.206 3 22.6001 3 22.9986C3 23.3971 3.08753 23.7912 3.25696 24.1555C3.4264 24.5199 3.67399 24.8465 3.98383 25.1143L22.9679 41.5171C24.0718 42.4713 25.5091 42.9999 26.9999 43H57C58.5913 43 60.1174 42.398 61.2426 41.3263C62.3679 40.2547 63 38.8012 63 37.2857V8.71429C63 7.19876 62.3679 5.74531 61.2426 4.67368C60.1174 3.60204 58.5913 3 57 3H26.9999Z" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default BackspaceIcon;

